import React, { useState, useEffect } from 'react';
import { Modal } from './Modal';

const TYPED_CONFIRM_WORD = 'DELETE';

export function ConfirmDialog({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  destructive = false,
  onConfirm,
  onCancel,
}) {
  const [typed, setTyped] = useState('');

  useEffect(() => {
    if (!isOpen) setTyped('');
  }, [isOpen]);

  if (!isOpen) return null;

  const requiresTyped = destructive;
  const canConfirm = !requiresTyped || typed === TYPED_CONFIRM_WORD;

  return (
    <Modal
      onClose={onCancel}
      role="alertdialog"
      aria-modal="true"
      aria-label={title}
    >
      <div style={{ padding: '8px 4px' }}>
        <h3 style={{ marginBottom: '12px' }}>{title}</h3>
        <p style={{ marginBottom: '20px', color: 'var(--color-text-muted)' }}>{message}</p>

        {requiresTyped && (
          <div className="form-group" style={{ marginBottom: '20px' }}>
            <label htmlFor="confirm-dialog-typed">
              Type <strong>{TYPED_CONFIRM_WORD}</strong> to confirm
            </label>
            <input
              id="confirm-dialog-typed"
              type="text"
              value={typed}
              onChange={(e) => setTyped(e.target.value)}
              autoFocus
            />
          </div>
        )}

        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            type="button"
            className="btn-primary"
            onClick={onConfirm}
            disabled={!canConfirm}
          >
            {confirmText}
          </button>
          <button type="button" className="btn-secondary" onClick={onCancel}>
            {cancelText}
          </button>
        </div>
      </div>
    </Modal>
  );
}
